import {getPickupTime, getShippingProviders} from "../network/deliveryApi";
import {useDeliveryStore} from "../store/deliveryStore";


export const fetchShippingProviders = async () => {
    const {setShippingProviders} = useDeliveryStore.getState();
    try {
        const response = await getShippingProviders();
        if (response.success) {
            setShippingProviders(response?.data);
        }
        return response;
    } catch (error) {
        console.error("Failed to fetch services", error);
    }
};
export const fetchPickupTime = async () => {
    const {setPickupTime} = useDeliveryStore.getState();
    try {
        const response = await getPickupTime();
        if (response.success) {
            const pickupTime = response?.data
            setPickupTime(pickupTime);
        }
        return response;
    } catch (error) {
        console.error("Failed to fetch services", error);
    }
};